export enum TooltipPositions {
  left = 'left',
  right = 'right',
  top = 'top',
  center = 'center',
  topLeft = 'topLeft',
  topRight = 'topRight',
  bottomRight = 'bottomRight'
}
